import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const ExternalLinkAltIcon = ({ label = 'ExternalLinkAlt', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M273.5 46.4h-69.7l13.4 13.4a5.9 5.9 0 0 1 0 8.2L86.9 198.3l34.7 34.7 130.2-130.3a5.9 5.9 0 0 1 8.3 0l13.4 13.4z" style="fill:#f4c223"/><path d="M273.5 46.4v69.7l-13.4-13.4a5.8 5.8 0 0 0-4.1-1.7 6.3 6.3 0 0 0-4.2 1.7L121.6 233l-34.7-34.7L217.2 68a5.9 5.9 0 0 0 0-8.2l-13.4-13.4h69.7m0-10h-69.7a10 10 0 0 0-9.3 6.2 10.2 10.2 0 0 0 2.2 10.9l10.5 10.4L79.8 191.3a10 10 0 0 0 0 14.1l34.7 34.7a10 10 0 0 0 14.1 0L256 112.7l10.4 10.5a10.1 10.1 0 0 0 7.1 2.9 8.4 8.4 0 0 0 3.8-.8 9.9 9.9 0 0 0 6.2-9.2V46.4a9.9 9.9 0 0 0-10-10z" style="fill:#1d1d1b"/><path d="M202.6 273.6H32.9A16.9 16.9 0 0 1 16 256.7V87.1a17 17 0 0 1 16.9-17h168.5a5 5 0 0 1 5 5 5 5 0 0 1-5 5H32.9a6.9 6.9 0 0 0-6.9 7v169.6a6.9 6.9 0 0 0 6.9 6.9h169.7a6.9 6.9 0 0 0 6.9-6.9V152.1a5 5 0 0 1 10 0v104.6a16.9 16.9 0 0 1-16.9 16.9z" style="fill:#1d1d1b"/><path style="fill:#f4c223" d="m149.1 186.2 5.7-5.7"/><path d="M149.1 189.2a2.9 2.9 0 0 1-2.1-.9 3 3 0 0 1 0-4.1l5.8-5.7a2.8 2.8 0 0 1 4.1 0 3 3 0 0 1 0 4.1l-5.7 5.7a3 3 0 0 1-2.1.9z" style="fill:#1d1d1b"/><path style="fill:#f4c223" d="m123.3 212.1 18.6-18.6"/><path d="M123.3 215a2.9 2.9 0 0 1-2.1-.9 3 3 0 0 1 0-4.1l18.6-18.6a3 3 0 0 1 4.1 0 2.8 2.8 0 0 1 0 4.1l-18.5 18.6a3 3 0 0 1-2.1.9z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

ExternalLinkAltIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { ExternalLinkAltIcon }
